import Link from "next/link"
import { StyledEmptyEntries } from "@/components/EmptyEntries/StyledEmptyEntries"
import { useAuth } from "@/hooks/auth/auth"
import { useModals } from "@/hooks/modals/useModals"
import { modalsAlias } from "@/store/reducers/commonSlice"
import { Button } from "@/ui/Button/Button"
import { Typography } from "@/ui/Typography/Typography"
import { ROUTES } from "@/utils/constants"

const EmptyEntries = () => {
  const { isInit, isAuth } = useAuth()
  const { show: showModal } = useModals()

  return (
    <StyledEmptyEntries>
      <Typography variant="h3">Пока здесь ничего нет</Typography>
      {isInit && !isAuth && (
        <Typography>
          <Button
            variant="link"
            onClick={(e) => {
              e.preventDefault()

              showModal({
                alias: modalsAlias.auth,
              })
            }}
          >
            Войдите
          </Button>
          , если уже добавляли товары в своем аккаунте или добавьте новые{" "}
          <Link href={ROUTES.catalog}>из каталога</Link>
        </Typography>
      )}
    </StyledEmptyEntries>
  )
}

export default EmptyEntries
